import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStylization = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 3,
			width: 18,
			height: 6.3,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.2002,
			y: 11.1,
			width: 10.8,
			height: 9.9,
			rx: 2,
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 3,
			y: 11.1,
			width: 5.4,
			height: 9.9,
			rx: 2,
			fill: "currentColor"
		})
	]
});
export default SvgStylization;
